import Services from 'services'

class RegistrasiBarangJadiApi {
    page(value) {
        return Services.get(`/registrasi_barang_jadi/page`, { params: { ...value } });
    }
    single(value) {
        return Services.get(`/registrasi_barang_jadi/single`, { params: { ...value } });
    }
    dropdown(value) {
        return Services.get(`/registrasi_barang_jadi/dropdown`, { params: { ...value } });
    }
    getAnalisa(params) {
        return Services.get(`registrasi_barang_jadi/salin_analisa`, { params });
    }
    no_baru() {
        return Services.get(`/registrasi_barang_jadi/no_baru`);
    }
    create(value) {
        return Services.post(`/registrasi_barang_jadi`, value);
    }
    update(value) {
        return Services.put(`/registrasi_barang_jadi`, value);
    }
    delete(value) {
        return Services.post(`/registrasi_barang_jadi/delete`, value);
    }
    show(value) {
        return Services.put(`/registrasi_barang_jadi/show`, value);
    }
    hide(value) {
        return Services.put(`/registrasi_barang_jadi/hide`, value);
    }
    uploadFileMultiple(data) {
        return Services.post("/upload/registrasi_barang_jadi_multiple", data);
    }
    uploadFile(data) {
        return Services.post("/registrasi_barang_jadi/gambar", data);
    }
    deleteFile(id) {
        return Services.post("/registrasi_barang_jadi/gambar_delete", id);
    }
    create_analisa(value) {
        return Services.post(`/registrasi_barang_jadi/analisa`, value);
    }
    update_analisa(value) {
        return Services.put(`/registrasi_barang_jadi/analisa`, value);
    }
    analisa_delete(value) {
        return Services.post(`/registrasi_barang_jadi/analisa_delete`, value);
    }
    cek_nama(params) {
        return Services.get('/registrasi_barang_jadi/cek_nama', { params });
    }
}

export default new RegistrasiBarangJadiApi();